import gql from 'graphql-tag';

export const NumberOfPagesLockedQuery = gql`
	query NumberOfPagesLockedQuery($status: [String], $type: String, $first: Int) {
		content(status: $status, type: $type, first: $first) {
			edges {
				node {
					id
					hasRestrictions
				}
			}
		}
	}
`;
